import React from "react";
import MIcon from "../../icons/MIcon";

const MessageBanner = ({ message }) => {
  if (!message.text) return null;
  return (
    <div
      className={`
        rounded-lg px-4 py-3 text-sm flex items-start gap-2.5 mt-4
        ${
          message.type === "success"
            ? "bg-emerald-500/10 dark:bg-emerald-400/10 border border-emerald-500/20 dark:border-emerald-400/20 text-emerald-600 dark:text-emerald-400"
            : "bg-red-500/10 dark:bg-red-400/10 border border-red-500/20 dark:border-red-400/20 text-red-600 dark:text-red-400"
        }
      `}
    >
      <span className="mt-0.5 shrink-0">
        <MIcon
          name={message.type === "success" ? "check_circle" : "error"}
          className="sm"
        />
      </span>
      <span>{message.text}</span>
    </div>
  );
};

export default MessageBanner;
